import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@material-ui/core";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "40px",
      }}
    >
      <Typography variant="h3" style={{ marginBottom: "16px", color: "#0f172a" }}>
        Page Not Available
      </Typography>
      <Typography variant="body1" style={{ maxWidth: "600px", marginBottom: "28px", color: "#475569" }}>
        You do not have access to this page or the URL is invalid. Please use the navigation menu or logout and login again.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/welcome")}
        style={{ textTransform: "none" }}
      >
        Go to Welcome Page
      </Button>
    </div>
  );
}
